import React from 'react';
import { Dialog, IconButton, makeStyles } from '@material-ui/core';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import { Close } from '@carbon/icons-react';
import { useQuitQuotationChatRoomMutation } from '@generated/graphql';
import { useSelector } from '@store';

interface Props {
  open: boolean;
  onClose: () => void;
}
const ChatQuitModal = ({ open, onClose }: Props) => {
  const classes = useStyles();
  const chatRoomId = useSelector((state) => state.chat.chatRoomId);

  const [closeTrigger] = useQuitQuotationChatRoomMutation();

  const close = async () => {
    if (!chatRoomId) return;

    await closeTrigger({
      variables: {
        chatRoomId: chatRoomId
      }
    });

    onClose();
  };

  return (
    <Dialog
      fullWidth
      open={open}
      onClose={onClose}
      classes={{ paper: classes.paper }}
    >
      <div className={classes.header}>
        <CustomizedTypography
          variant="h4"
          color="textPrimary"
          fontWeight="bold"
        >
          상담 종료하기
        </CustomizedTypography>
        <IconButton className="close" onClick={onClose}>
          <Close />
        </IconButton>
      </div>
      <div className={classes.content}>
        <CustomizedTypography
          variant="h4"
          color="textPrimary"
          gutterBottoms={4}
        >
          상담을 종료하시겠습니까?
        </CustomizedTypography>
        <CustomizedTypography variant="body1" color="textSecondary">
          더 이상 상담을 진행하지 않으시면 상담을 종료해주세요.
        </CustomizedTypography>
      </div>
      <div className={classes.footer}>
        <CustomizedButton
          onClick={close}
          fullWidth
          variant="contained"
          color="error"
          size="large"
        >
          상담 종료하기
        </CustomizedButton>
        <CustomizedButton
          onClick={onClose}
          fullWidth
          variant="contained"
          color="default"
          size="large"
        >
          취소
        </CustomizedButton>
      </div>
    </Dialog>
  );
};

export default ChatQuitModal;

const useStyles = makeStyles((theme) => ({
  paper: {
    maxWidth: 476,
    padding: 0,
    borderRadius: 16,
    '& h4': {
      wordBreak: 'break-all'
    }
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '28px 24px',
    [theme.breakpoints.down('md')]: {
      padding: '28px 20px'
    },
    '& .close': {
      padding: 0,
      '& svg': {
        width: 24,
        height: 24
      }
    }
  },
  content: {
    padding: '0px 24px 24px',
    [theme.breakpoints.down('md')]: {
      padding: '0px 24px px'
    }
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 24px',
    '& button': {
      width: 'calc(100% / 2 - 4px)'
    },
    [theme.breakpoints.down('md')]: {
      padding: '16px'
    }
  }
}));
